var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderTestcaseKatalonStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.938a.45.45 0 0 0-.438.437v4.43c.137-.028.274-.055.438-.055h10.5c.137 0 .273.027.438.055v-4.43a.47.47 0 0 0-.438-.438H1.75zM1.312 8.5v2.625c0 .246.192.438.438.438h10.5a.45.45 0 0 0 .438-.438V8.5a.47.47 0 0 0-.438-.438H1.75a.45.45 0 0 0-.438.438zM0 8.5V2.375C0 1.418.766.625 1.75.625h10.5c.957 0 1.75.793 1.75 1.75v8.75c0 .984-.793 1.75-1.75 1.75H1.75c-.984 0-1.75-.766-1.75-1.75V8.5zm7.656 1.313c0-.356.274-.657.657-.657.355 0 .656.301.656.656 0 .383-.301.657-.656.657a.632.632 0 0 1-.657-.656zm3.282-.657c.355 0 .656.301.656.656 0 .383-.301.657-.656.657a.632.632 0 0 1-.657-.656c0-.356.274-.657.656-.657z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTestcaseKatalonStudio);
export default __webpack_public_path__ + "static/media/folder-testcase-katalon-studio.9ed06ba3078cb48d0cae9049f647f986.svg";
export { ForwardRef as ReactComponent };